var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );
dependencies["front/utils/sites.jinja"] = require( "front/utils/sites.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/MyADGAvailabilityPopup/MyADGAvailabilityPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/MyADGAvailabilityPopup/MyADGAvailabilityPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/MyADGAvailabilityPopup/MyADGAvailabilityPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n";
env.getTemplate("front/utils/sites.jinja", false, "assets/app/front/pages/MyADGAvailabilityPopup/MyADGAvailabilityPopup.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("sites", t_7);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupClasses"))(env, context, frame, runtime, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
output += t_10;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
output += t_12;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupClasses(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "BasePopup--transparentLeft";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"MyADGAvailabilityPopup\">\n        <div class=\"MyADGAvailabilityPopup-content\">\n            <div class=\"MyADGAvailabilityPopup-contentWrapper\">\n                <h2 class=\"MyADGAvailabilityPopup-title\">My Availability</h2>\n                <div class=\"MyADGAvailabilityPopup-annotation\">Before you set your availability, be sure to <a href=\"";
output += runtime.suppressValue((lineno = 11, colno = 120, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:myadg_job-popup"])), env.opts.autoescape);
output += "\">report your work</a>. <br>The availability list is always <a class=\"u-skipUrlParser\" href=\"";
output += runtime.suppressValue((lineno = 11, colno = 249, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "domain_url"), "domain_url", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "sites")),"SITE_AVAILABILITY"),"index"])), env.opts.autoescape);
output += "\" target=\"_blank\">available for download</a>.</div>\n\n                <div class=\"MyADGAvailabilityPopup-list\">\n                ";
frame = frame.push();
var t_16 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"list");
if(t_16) {t_16 = runtime.fromIterator(t_16);
var t_15 = t_16.length;
for(var t_14=0; t_14 < t_16.length; t_14++) {
var t_17 = t_16[t_14];
frame.set("item", t_17);
frame.set("loop.index", t_14 + 1);
frame.set("loop.index0", t_14);
frame.set("loop.revindex", t_15 - t_14);
frame.set("loop.revindex0", t_15 - t_14 - 1);
frame.set("loop.first", t_14 === 0);
frame.set("loop.last", t_14 === t_15 - 1);
frame.set("loop.length", t_15);
output += "<div class=\"MyADGAvailabilityPopup-listItem ";
if(((!runtime.memberLookup((t_17),"limited")) && runtime.memberLookup((t_17),"selected"))) {
output += "MyADGAvailabilityPopup-listItem--dates";
;
}
output += " clearfix\" data-available=\"";
if((runtime.memberLookup((t_17),"selected"))) {
output += "1";
;
}
else {
output += "0";
;
}
output += "\" data-limited=\"";
if((runtime.memberLookup((t_17),"limited"))) {
output += "1";
;
}
else {
output += "0";
;
}
output += "\" data-disabled=\"";
if((runtime.memberLookup((t_17),"disabled"))) {
output += "1";
;
}
else {
output += "0";
;
}
output += "\">\n                        <div class=\"MyADGAvailabilityPopup-listColumn-1\">\n                            <div class=\"MyADGAvailabilityPopup-listItemPosition\" data-position=\"";
output += runtime.suppressValue(runtime.memberLookup((t_17),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_17),"display"), env.opts.autoescape);
output += "</div>\n                        </div>\n\n                    ";
if(runtime.memberLookup((t_17),"disabled")) {
output += "<div class=\"MyADGAvailabilityPopup-listColumn-2-4\">\n                            To change your status on the ";
output += runtime.suppressValue(runtime.memberLookup((t_17),"craft"), env.opts.autoescape);
output += " Availability List, please contact the ADG office at <a href=\"tel:(818) 762-9995\">(818) 762-9995</a> or <a href=\"mailto:laura@adg.org\">laura@adg.org</a>\n                        </div>\n                    ";
;
}
else {
output += "<div class=\"MyADGAvailabilityPopup-listColumn-2\">\n                            <div class=\"MyADGAvailabilityPopup-listItemRadio\" data-switch=\"1\"><div></div>Available</div>\n                            ";
if((!runtime.memberLookup((t_17),"limited"))) {
output += "\n                                <div class=\"MyADGAvailabilityPopup-listItemDate\" data-type=\"from\" style=\"display: ";
if((runtime.memberLookup((t_17),"selected"))) {
output += "block";
;
}
else {
output += "none";
;
}
output += "\" data-date=\"";
if((runtime.memberLookup((t_17),"selected") && runtime.memberLookup((t_17),"start"))) {
output += runtime.suppressValue(runtime.memberLookup((t_17),"start"), env.opts.autoescape);
;
}
output += "\"><span>";
if((runtime.memberLookup((t_17),"selected") && runtime.memberLookup((t_17),"start"))) {
output += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_17),"start"),"%m/%d/%y"), env.opts.autoescape);
;
}
else {
output += "START DATE";
;
}
output += "</span></div>\n                            ";
;
}
output += "\n                        </div>\n\n                        <div class=\"MyADGAvailabilityPopup-listColumn-3\">\n                            <div class=\"MyADGAvailabilityPopup-listItemRadio\" data-switch=\"0\"><div></div>Not Available</div>\n                            ";
if((!runtime.memberLookup((t_17),"limited"))) {
output += "\n                                <div class=\"MyADGAvailabilityPopup-listItemDate\" data-type=\"to\" style=\"display: ";
if((runtime.memberLookup((t_17),"selected"))) {
output += "block";
;
}
else {
output += "none";
;
}
output += "\" data-date=\"";
if((runtime.memberLookup((t_17),"selected") && runtime.memberLookup((t_17),"end"))) {
output += runtime.suppressValue(runtime.memberLookup((t_17),"end"), env.opts.autoescape);
;
}
output += "\"><span>";
if((runtime.memberLookup((t_17),"selected") && runtime.memberLookup((t_17),"end"))) {
output += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_17),"end"),"%m/%d/%y"), env.opts.autoescape);
;
}
else {
output += "END DATE";
;
}
output += "</span></div>\n                            ";
;
}
output += "\n                        </div>\n\n                        <div class=\"MyADGAvailabilityPopup-listColumn-4\">\n                            <div class=\"MyADGAvailabilityPopup-listItemInfo\">\n                                <div class=\"MyADGAvailabilityPopup-listItemInfoIcon\">?</div>\n                                <div class=\"MyADGAvailabilityPopup-listItemInfoPopup\">\n                                    ";
if((!runtime.memberLookup((t_17),"limited"))) {
output += "\n                                        You can set yourself as available for as long you would like.<br><br> However, in order to ensure the Availability List is up to date, we encourage you to only set yourself as available for the period of time that you actual are.\n                                    ";
;
}
else {
output += "\n                                        At the end of the month the Availability List gets purged in order to keep it up to date.<br><br> If you set yourself as available up to 5 days before the end of the month, you will also be included in the next month’s Availability List.\n                                    ";
;
}
output += "\n                                </div>\n                            </div>\n                        </div>\n\n                    ";
;
}
output += "</div>\n                ";
;
}
}
frame = frame.pop();
output += "\n                </div>\n\n                <button class=\"MyADGAvailabilityPopup-update\"></button>\n            </div>\n        </div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupClasses: b_popupClasses,
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/MyADGAvailabilityPopup/MyADGAvailabilityPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/MyADGAvailabilityPopup/MyADGAvailabilityPopup.jinja
// module id = 539
// module chunks = 0